// 各カラムの表示幅を定義する設定ファイル（pattern_name 単位）
export const COLUMN_WIDTH = {
  title: "230px",
  auto_number: "128px",
  category_name: "135px",
  purpose: "100px",
  issue_datetime: "100px",
  product_no: "94px",
  assignee: "150px",
  document_type: "90px",
  original_doc_number: "90px",
  remarks: "80px"
};

// カラムごとの表示スタイル設定
export const COLUMN_STYLE = {
  issue_datetime: {
    whiteSpace: "nowrap",  // 改行させない
    textAlign: "center",   // 中央寄せ表示
  },
};

// 幅が未定義のカラムに適用されるデフォルト値
export const DEFAULT_COLUMN_WIDTH = "120px";
